import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Loader from "Components/UI/Loader";
import Leftbar from "Components/Comman/Leftbar";
import Header from "Components/Comman/Header";

import { ls_vars, routes } from "Library/Constants";
import { useAuth } from "Hooks/useAuth";
import { useDashboardSettings } from "Hooks/useDashboardSettings";
import { getLocalStorage, setLocalStorage } from "Network/ApiService";
import { getProjects } from "Network/Core/Projects";

const PrivateLayout = ({ children }: any) => {
  const { isLoading: isDashboardLoading, initializeDashboard } =
    useDashboardSettings();
  const { isLoading: isAuthLoading, initializeAuth } = useAuth();
  const [isProjectRefLoading, setIsProjectRefLoading] = useState(
    () => !getLocalStorage(ls_vars.PROJECT_REF)
  );

  const initializeDefaultProjectRef = async () => {
    if (getLocalStorage(ls_vars.PROJECT_REF)) {
      setIsProjectRefLoading(false);
      return;
    }
    try {
      const res = await getProjects({ page: 1, pageSize: 1 });
      const ref = res?.data?.results?.[0]?.ref;
      if (ref) setLocalStorage(ls_vars.PROJECT_REF, ref);
    } finally {
      setIsProjectRefLoading(false);
    }
  };

  useEffect(() => {
    initializeDashboard();
    initializeAuth();
    initializeDefaultProjectRef();
  }, []);

  if (isDashboardLoading || isAuthLoading || isProjectRefLoading) return <Loader />;
  return children;
};

export default function PrivateRoutes() {
  const { isAuthorized } = useAuth();

  if (!isAuthorized) return <Navigate to={routes.root.token} />;
  return (
    <PrivateLayout>
      <Header />
      <div id="wrapper">
        <Leftbar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Outlet />
          </div>
        </div>
      </div>
    </PrivateLayout>
  );
}
